import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    timezones: [],
};

const getters = {
    timezones: state => state.timezones,
};

const mutations = {
    setTimezones(state, data) {
        state.timezones = data;
    },
};

const actions = {
    async getTimezones({ commit, dispatch }) {
        let route = Laroute.route('franchise.vue.timezone');

        startLoading(dispatch, 'timezone');

        return axios
            .get(route)
            .then(res => {
                commit('setTimezones', res.data);
                endLoading(dispatch, 'timezone');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'timezone');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
